import { render } from "./JobKpis.vue?vue&type=template&id=3aa7b3d2&scoped=true"
import script from "./JobKpis.vue?vue&type=script&lang=js"
export * from "./JobKpis.vue?vue&type=script&lang=js"

import "./JobKpis.vue?vue&type=style&index=0&id=3aa7b3d2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa7b3d2"]])

export default __exports__